import axios from 'axios';

import {
  apiAdministrationApp,
  apiCertificationsAdminContracts,
  apiMasterCertifications,
  apiUrl,
  apiYClickMaster
} from '../resources/environmentConstants';

import { apiInterceptors } from './apiInterceptors';

// Api  Servicios
const apiInstance = axios.create({
  baseURL: apiUrl
});

apiInterceptors(apiInstance);

// Api Maestros
const apiYclickMasterInstance = axios.create({
  baseURL: apiYClickMaster
});

apiInterceptors(apiYclickMasterInstance);

// Api Certificaciones - Admin Contratos
const apiAdminContractsInstance = axios.create({
  baseURL: apiCertificationsAdminContracts
});

apiInterceptors(apiAdminContractsInstance);

// Api Maestro Certificaciones
const apiCertificationsMasterInstance = axios.create({
  baseURL: apiMasterCertifications
});

apiInterceptors(apiCertificationsMasterInstance);

// Api Maestro Administracion
const apiAdministrationMasterInstance = axios.create({
  baseURL: apiAdministrationApp
});

apiInterceptors(apiAdministrationMasterInstance);
export {
  apiInstance as api,
  apiYclickMasterInstance as apiYclickMaster,
  apiAdminContractsInstance as apiAdminContracts,
  apiCertificationsMasterInstance as apiCertificationsMaster,
  apiAdministrationMasterInstance as apiAdministrationMaster
};
